import { ActivityType, IActivityMetadata } from "@/shared/services/interface/responses/IInboxResponses";
import ActivityItem from "./activity-item";
import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
export interface IActivity {
  activityId: string;
  createdAt: string;
  deletedAt: string | null;
  firstName: string;
  profilePictureUrl?: string | null;
  type: ActivityType;
  metadata?: IActivityMetadata;
}

interface IActivityItemsExpandableProps {
  activities: IActivity[];
  targetId: string;
}

export default function ActivityItemsExpandable({ activities, targetId }: IActivityItemsExpandableProps) {
  const totalActivities = activities.length;
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <ActivityItem
        activity={activities[0]}
        targetId={targetId}
      />
      {
        totalActivities > 1 && (
          <div className="flex px-[8px] py-[4px] items-center gap-2 cursor-pointer" onClick={handleToggleExpand}>
            <ChevronRight size={14} strokeWidth={1} color="#A1A1AA" className={cn("transition-transform duration-200", isExpanded ? "rotate-90" : "")} />
            <div className="text-[11px] font-regular text-[#A1A1AA] leading-[16px]">
              {totalActivities - 1} more
            </div>
          </div>
        )
      }
      {isExpanded && activities.map((activity, index) => {
        if (index === 0) return null;
        return (
          <ActivityItem
            key={activity.activityId}
            activity={activity}
            targetId={targetId}
          />
        )
      })}
    </>
  );
}